import React from "react";
import Meta from "../../components/Meta";
import Image from "next/image";
import OurWhy from "./ourWhy";
import OurEcosystemGrid from "../../components/homepage_redesign/ourEcosystem";
import { features } from "../../data/home_data";
import FeaturesGrid from "../../components/homepage_redesign/feature_grid";
import {
  FaLightbulb,
  FaHandsHelping,
  FaRocket,
  FaShieldAlt,
  FaUsers,
  FaPaintBrush,
  FaHeart,
} from "react-icons/fa"; // Importing Font Awesome icons
import Team from "../../components/about/Team";
import TechStack from "../../components/about/tech-stack";
import CollabHub from "../../components/home/collabHub";
import ImpactoverseFor from "../../components/homepage_redesign/impactoverseFor";

const ourValues = [
  {
    title: "Impact-First Thinking",
    description:
      "We focus on outcomes, not just outputs. Everything we build, support, or co-create must lead to tangible and meaningful change.",
    icon: FaLightbulb,
  },
  {
    title: "Collaborative Scale",
    description:
      "We believe the biggest change happens together. By building bridges between people, causes, organizations, and sectors, we multiply our impact far beyond what’s possible alone.",
    icon: FaHandsHelping,
  },
  {
    title: "Purpose-Driven Innovation",
    description:
      "We design with intention, combining creativity, empathy, and technology to solve real problems and unlock new possibilities for good.",
    icon: FaRocket,
  },
  {
    title: "Transparency & Trust",
    description:
      "Accountability is central to our mission. We make actions and outcomes transparent.",
    icon: FaShieldAlt,
  },
  {
    title: "Fair Inclusion",
    description:
      "We strive to ensure that access to tools, knowledge, and opportunity is fair and inclusive.",
    icon: FaUsers,
  },
  {
    title: "Creativity as Catalyst",
    description:
      "Art, storytelling, and play are not extras, they’re essential drivers of connection, empathy, engagement, and deeper impact.",
    icon: FaPaintBrush,
  },
  {
    title: "Community-Led Change",
    description:
      "We elevate the knowledge, needs, and leadership of those closest to the issues. Communities are not audiences, they are co-creators.",
    icon: FaHeart,
  },
];

// Main App component
const App = () => {
  return (
    <>
      <Meta title="Art for Impact Compaigns || Impactoverse" />
      <section className="relative pt-[9rem] lg:pb-24 text-center">
        <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden !ml-0">
          <Image
            width={1519}
            height={773}
            priority
            src="/images/gradient_light.jpg"
            alt="gradient"
            className="h-full w-full object-cover"
          />
        </picture>
        <div className="lg:flex lg:space-x-12">
          <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden !ml-0">
            <Image
              width={1519}
              height={935}
              src="/images/gradient.jpg"
              alt="gradient"
              className="h-full w-full object-cover"
            />
          </picture>
          <picture className="pointer-events-none absolute inset-0 -z-10 hidden dark:block !ml-0">
            <Image
              width={1519}
              height={935}
              src="/images/gradient_dark.jpg"
              alt="gradient dark"
              className="h-full w-full object-cover"
            />
          </picture>
        </div>
        <div className="container mx-auto text-center">
          <h1 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase">
            The
            <span className="animate-gradient"> What</span>
            <br />
          </h1>
          <h3 className="font-display max-sm:my-5 text-2xl text-jacarta-700 dark:text-white lg:text-2xl xl:text-3xl text-center uppercase">
            Technology that Empowers Impact Through <br/> Play, Creativity, and
            Purpose
          </h3>
          <p className="text-lg dark:text-jacarta-50">
            Impactoverse is a next-generation ecosystem that makes real-world
            impact engaging, creative, and measurable. Through gamified
            learning, purpose-driven art, and ethical commerce, we provide
            individuals, organizations, and communities with the tools to learn,
            act, and support causes they care about, building and uplifting
            communities and solving real problems.
            <br />
            Whether you&apos;re here to create, play or shop for impact,
            everything you do in the Impactoverse ecosystem contributes to
            real-world change, meaningfully shared.
          </p>
        </div>
        {/* <button className=" mx-auto mt-8 px-8 py-4 bg-accent shadow-accent-volume hover:bg-accent-dark rounded-full py-3 px-8 text-center font-semibold text-white transition-all">
            Explore Campaigns
          </button> */}
      </section>

      <section className="relative pt-24 lg:pb-10">
        <div className="container mx-auto text-center">
          <h1 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase mb-6">
            THE
            <span className="animate-gradient"> Why</span>
          </h1>

          <OurWhy />
        </div>
      </section>
      <ImpactoverseFor />
      <div className="antialiased">
        <div className="mb-20">
          <h3 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase mb-12">
            OUR <span className="animate-gradient"> ECOSYSTEM</span>
          </h3>
          {/* <OurEcosystemGrid /> */}
          <FeaturesGrid features={features} />
        </div>

        <section className="py-16 px-4 sm:px-8 ">
          <div className="max-w-6xl mx-auto">
            <h3 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase mb-12">
            OUR <span className="animate-gradient"> VALUES</span>
          </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {ourValues.map((value, index) => (
                <>
                  <div
                    key={index}
                    className="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 rounded-2.5xl mb-8 border bg-white p-8 text-center transition-shadow hover:shadow-lg flex flex-col items-center"
                  >
                    <div className="rounded-full w-20 h-20 m-4 flex items-center justify-center bg-accent-dark pt-4">
                      {value.icon && (
                        // react-icons components accept a 'size' prop and other SVG props
                        <value.icon
                          className="text-purple-600 mb-4 color-white"
                          size={48}
                        />
                      )}
                    </div>
                    <h3 className="mb-2 mt-1 block font-display text-xl font-medium group-hover:text-accent dark:text-white uppercase">
                      {value.title}
                    </h3>
                    <p className="text-lg dark:text-jacarta-300">
                      {value.description}
                    </p>
                  </div>
                </>
              ))}
            </div>
          </div>
        </section>


        {/* MEET OUR ADVISORS Section */}
        <Team />
        {/* ABOUT THE FOUNDER Section */}
        <section className="px-6 lg:px-16 py-16 sm:py-24 md:py-32 bg-gray-100 rounded-lg m-4 sm:m-6 md:m-8">
          <div className="max-w-7xl mx-auto text-center">
             <h3 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase mb-12">
            ABOUT <span className="animate-gradient"> THE FOUNDER</span>
          </h3>
            <div className="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 rounded-2.5xl mb-8 border bg-white p-8 text-center transition-shadow hover:shadow-lg max-w-3xl mx-auto bg-white p-8 rounded-xl shadow-md flex flex-col md:flex-row items-center md:items-start space-y-6 md:space-y-0 md:space-x-8">
              <Image
                src="/images/team/team_1.jpg"
                alt="Noleen Mariappen"
                width={150}
                height={150}
                className="w-32 h-32 rounded-full object-cover shadow-lg flex-shrink-0"
              />
              <div className="text-left">
                <h3 className="text-2xl font-semibold text-gray-800 mb-2 rounded-lg">
                  Noleen Mariappen
                </h3>
                <p className="text-gray-600 font-medium mb-4 rounded-lg">
                  Founder, Impactoverse
                </p>
                <p className="text-gray-700 leading-relaxed rounded-lg">
                  Noleen Mariappen is the Founder of Impactoverse and a
                  purpose-driven innovator, systems strategist, and social
                  impact leader dedicated to advancing equity and collaboration
                  at scale. She created Impactoverse to harness the power of
                  technological innovation to unify what often exists in silos:
                  equitable access, education, creativity, and meaningful action
                  for impact. Her goal was to build one interconnected platform
                  that empowers people everywhere to be empowered to co-create
                  global good.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* <TechStack />

        <CollabHub /> */}
      </div>
    </>
  );
};

export default App;
